import React from 'react';
import { Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
const TechnicalProofNavigationLinks = _ref => {
  let {
    claimGroup,
    user,
    page
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, {
    as: Link,
    active: page === 'project_reports',
    to: `/${user.account_type}/claim_groups/${claimGroup.id}/technical_proof/project_reports`
  }, t('project_report'))), /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, {
    as: Link,
    active: page === 'affiliated_companies',
    to: `/${user.account_type}/claim_groups/${claimGroup.id}/technical_proof/affiliated_companies`
  }, "Affiliated Companies")), /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, {
    as: Link,
    active: page === 'final_instructions',
    to: `/${user.account_type}/claim_groups/${claimGroup.id}/technical_proof/final_instructions`
  }, "Final Instructions")));
};
export default TechnicalProofNavigationLinks;